export const ErrorHandling = (error, Config, setState, childAlerta) => {
    let errorString = 'Erro ao carregar dados!';
    if (Config.DEBUG === 'TRUE') {
        errorString = error.message;
    }
    setState({
        isError: true,
        isLoading: false,
        error: errorString,
    });
    childAlerta.current.retorno(error.message, 'error');
};
